import { createI18n } from "vue-i18n";
import en from "./en.json";
import sv from "./sv.json";

const locale = document.getElementsByTagName("html")[0].getAttribute("lang");

const i18n = createI18n({
    legacy: false,
    locale: locale || "en",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    globalInjection: true,
    messages: { sv, en },
});

export default i18n;
